// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import get from 'lodash/get'
import moment from 'moment'
import React, { Component } from 'react'
import { Query } from 'react-apollo'
import Loader from '../../../common/loader/Loader'
import { alphaSort } from '../../../common/utils'
import { i18n } from '../../index'
import withActiveStation from '../../station/withActiveStation'
import MonthDisplay from '../MonthDisplay'
import ProductTypeSelector, { DEFAULT_PRODUCT_TYPE } from '../common/ProductTypeSelector'
import CustomerSalesGraph from './CustomerSalesGraph'
import CustomerSalesTable from './CustomerSalesTable'
import css from './customerSales.css'
import { fetchReportMonthlyCustomerSales } from './customerSalesQueries'

type Props = {
  activeStation: any
}
type State = {
  productType:
    | 'Buffet'
    | 'Sweet'
    | 'Salty'
    | 'ALaCarte'
    | 'AbcPizzaTable'
    | 'ABCPizza'
    | 'ABCBurger'
    | 'PikaCarte'
    | 'Arnolds'
    | 'AbcBuffetWorld'
  selectedDate: moment
}

@withActiveStation
class CustomerSales extends Component<Props, State> {
  state = {
    type: DEFAULT_PRODUCT_TYPE,
    selectedMonth: moment(),
  }
  onProductTypeChange = (option: any) => {
    this.setState({
      type: option.value,
    })
  }
  onMonthChange = (step: number) => {
    this.setState({
      selectedMonth: this.state.selectedMonth.clone().add(step, 'months'),
    })
  }

  render() {
    const { activeStation } = this.props
    const { type, selectedMonth } = this.state
    const [month, year] = selectedMonth.format('MM-YYYY').split('-')
    return (
      <Query
        query={fetchReportMonthlyCustomerSales}
        variables={{
          stationId: activeStation && activeStation.id,
          year: Number(year),
          month: Number(month),
          type,
        }}
      >
        {({ loading, error, data }) => (
          <div className={css.component}>
            <span className={css.label}>{i18n.t('reporting.productGroup')}</span>
            <ProductTypeSelector
              onChange={this.onProductTypeChange}
              value={type}
              stationSettings={data.stationSettings}
            />
            <MonthDisplay selectedMonth={selectedMonth} onMonthChange={this.onMonthChange} />
            <Loader
              {...{
                loading,
                error,
              }}
            >
              <CustomerSalesTable data={alphaSort('date', get(data, 'reportMonthlyCustomerSales', []))} />
              <CustomerSalesGraph month={month} year={year} data={data} />
            </Loader>
          </div>
        )}
      </Query>
    )
  }
}

export default CustomerSales
